import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import Header from "../../../../../components/HeaderForms/HeaderForms";

export const RequisitosPruebasCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "REQUISITOS PARA EL PROCESO DE PRUEBAS DE CONFIANZA";
  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFechaFG = useMutationData({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const mutateRequisitosPruebas = useMutationData({
    url: `/requisitos_pruebas/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "requisitos_pruebas"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
            };

            // Mutación para guardar la Fecha de Requisitos de Pruebas
            mutateFechaFG.mutate(
              {
                data: { fecha_requisitos_pruebas: data.fecha_requisitos_pruebas },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  mutateRequisitosPruebas.mutate(
                    {
                      data: formData,
                      tipo: "post",
                    },
                    {
                      onSuccess: () => {
                        navigate(`/formatosG/${evaluadosList_id}`);
                        window.scrollTo(0, 0);
                      },
                      onError: (error) => {
                        console.error(
                          "Error al guardar Requisitos de Pruebas:",
                          error
                        );
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Formatos Generales:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />
          {/* Contenido del formulario */}
          <div className="p-6 flex flex-col gap-6">
            <h2 className={`text-xl font-bold mb-4 text-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              REQUISITOS PARA EL PROCESO DE PRUEBAS DE CONFIANZA
            </h2>
            {/* Texto principal */}
            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Presentarse en las oficinas ubicadas en <strong>Calle</strong>
              <Controller
                name="calle_rp"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="calle_rp"
                    type="text"
                    {...field}
                    className={`border rounded-md p-2 w-[300px] ml-2 font-bold ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-500" : "border-gray-400 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"}`}
                  />
                )}
              />{" "}
              <strong>No.</strong>
              <Controller
                name="no_rp"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="no_rp"
                    type="number"
                    {...field}
                    className={`border rounded-md p-2 w-[50px] ml-2 font-bold ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-500" : "border-gray-400 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"}`}
                  />
                )}
              />{" "}
              <strong>Colonia Juárez, Delegación Cuauhtémoc, C.P.</strong>
              <Controller
                name="cp_rp"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="cp_rp"
                    type="text"
                    {...field}
                    className={`border rounded-md p-2 w-[100px] ml-2 font-bold ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-500" : "border-gray-400 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"}`}
                  />
                )}
              />
              <strong>, Ciudad de México.</strong>
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Para su comodidad los evaluados deberán preferentemente asistir con
              vestimenta casual y con{" "}
              <strong>
                <u>identificación oficial con fotografía</u>
              </strong>
              , y una fotocopia de esta.
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Se requiere que el día de la evaluación, el evaluado presente
              justificante médico, debidamente firmado por el médico tratante
              señalando número de cedula profesional y si padece alguna enfermedad
              o se encuentra tomando algún medicamento, favor de referirlo y
              presentar comprobante médico.
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Con la finalidad de agilizar el proceso y por motivo de espacios se
              recomienda no acudir con acompañantes, mochilas, maletas, bolsas
              voluminosas, equipo de cómputo, etc., se recomienda solo ingresar
              con la documentación requerida, lápiz, pluma, sacapuntas, etc.
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Es necesario{" "}
              <u>
                que los evaluados{" "}
                <strong>presenten el día de las pruebas de confianza</strong> la
                siguiente documentación, en caso de que no acuda con la
                documentación se dará aviso inmediato a la empresa:
              </u>
            </p>

            <ul className={`list-disc text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <li>
                <strong>
                  Documentos en original para su cotejo y entrega de copias:
                </strong>
                <br />
                - Acta de nacimiento
                <br />
                - Curriculum vitae, actualizado con fotografía, engrapado y con
                firma autógrafa en cada hoja, detalle su trayectoria laboral de
                empleos formales e infórmales, cursos de capacitación, entregue
                sin engargolar, no agregar constancias ni reconocimientos, solo
                menciónelos.
                <br />- Identificación oficial con fotografía, (Credencial de
                elector, Pasaporte, o Cedula Profesional) (Dos copias) anote con
                letra de molde en las copias y en espacio visible su nombre
                completo iniciando por apellidos en cada uno de ellos y la leyenda
                que se encuentra a continuación
              </li>
            </ul>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Bajo protesta de decir verdad, hago constar que la presente
              fotocopia fue tomada del documento original, mismo que cuenta con
              validez oficial y fue expedido por una institución con
              reconocimiento gubernamental. Hago entrega a la empresa SKA TRACKING
              AND SECURITY S.A. de C.V. a los
              <Controller
                name="fecha_requisitos_pruebas"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="fecha_requisitos_pruebas"
                    type="date"
                    {...field}
                    className={`border rounded-md p-2 w-[150px] ml-2 font-bold ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-500" : "border-gray-400 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"}`}
                  />
                )}
              />
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <strong>Nombre:</strong> {queryEvaluado.data?.nombre || ""}{" "}
              {queryEvaluado.data?.apellido_paterno || ""}{" "}
              {queryEvaluado.data?.apellido_materno || ""}
              <br />
              <strong>Empresa:</strong>{" "}
              {queryEvaluado.data?.empresa_id?.nombre || ""}
              <br />
              <strong>Puesto:</strong> {queryEvaluado.data?.puesto || ""}
              <div className="mt-[50px]"></div>
              <strong>Firma:</strong> _______________________
            </p>

            <ul className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <li>
                <br />
                - Credencial de la empresa (no aplica para procesos de inicio)
                <br />
                - CURP
                <br />
                - Licencia para conducir, aunque esta vencida si fuera el caso
                <br />- Comprobantes de domicilio en el que habita actualmente,
                mismo en donde, de ser el caso se le realizará la visita
                domiciliaria notificándole con antelación; la documentación
                requerida deberá contar con una antigüedad no mayor a dos meses al
                momento de su entrega. (recibos prediales, agua, gas, televisión
                de paga y estados de cuenta bancaria, no es necesario que aparezca
                Usted como titular) anote con letra de molde y en espacio visible
                su nombre completo iniciando por apellidos en cada uno de ellos y
                la leyenda que se encuentra a continuación
              </li>
            </ul>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Bajo protesta de decir verdad hago constar que la presente fotocopia
              fue tomada del documento original, mismo que cuenta con validez
              oficial y fue expedido por institución con reconocimiento
              gubernamental. Hago entrega a la empresa SKA TRACKING AND SECURITY
              S.A. de C.V. a los
              <Controller
                name="fecha_requisitos_pruebas"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="fecha_requisitos_pruebas"
                    type="date"
                    {...field}
                    className={`border rounded-md p-2 w-[150px] ml-2 font-bold ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-500" : "border-gray-400 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"}`}
                  />
                )}
              />
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <strong>Nombre:</strong> {queryEvaluado.data?.nombre || ""}{" "}
              {queryEvaluado.data?.apellido_paterno || ""}{" "}
              {queryEvaluado.data?.apellido_materno || ""}
              <br />
              <strong>Empresa:</strong>{" "}
              {queryEvaluado.data?.empresa_id?.nombre || ""}
              <br />
              <strong>Puesto:</strong> {queryEvaluado.data?.puesto || ""}
              <div className="mt-[50px]"></div>
              <strong>Firma:</strong> _______________________
            </p>

            <ul className={`list-disc text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <li>
                <br />
                - Último comprobante de pago de las colegiaturas de cada uno de
                los hijos que dependan del evaluado o de su esposa
                <br />
                - Acta de matrimonio o concubinato y/o sentencia de divorcio
                <br />
                - Comprobantes de ingresos, preferentemente de pago de nómina (Dos
                últimos meses)
                <br />
                - Comprobantes de ingresos, preferentemente de pago de nómina (Dos
                últimos meses) de su esposa o cónyuge.
                <br />
                - Constancia de Situación Fiscal
                <br />
                - Dos últimos estados de cuenta de instituciones bancarias, a
                nombre del evaluado o de su esposa y/o cónyuge.
                <br />
                - Dos últimos estados de cuenta de Tiendas departamentales.
                <br />
                - Consulta personal en el buró de crédito
                (www.burodecredito.com.mx)
                <br />
                - Consulta personal en el círculo de crédito
                (www.circulodecredito.com.mx)
                <br />
                - Dos referencias laborales de sus jefes inmediatos; en una hoja
                anote los siguientes datos: nombre, cargo, empresa, puesto,
                teléfono. Solo aplica para personal que labora (original).
                <br />
                - En caso de que su evaluación sea para incorporarse por primera
                vez a la empresa, presentar dos cartas laborales que indiquen:
                puesto, función, fecha de ingreso y motivo de la renuncia, así
                como el teléfono de la persona que firma, si es números celulares
                anotar también un número fijo.
                <br />
                - Dos referencias personales que no sean de familiares, con los
                siguientes datos: nombre y relación que tiene con usted, tiempo de
                conocerlo, teléfonos de casa y/o trabajo (si es número celulares
                anotar también un número fijo).
                <br />- Certificado de Estudios (último grado concluido) y/o
                cédula profesional (Original) y (2 copias por ambas caras); mismos
                que deberán contar con las siguientes características: ser
                legibles, completos y por ambos lados del documento. Con los datos
                señalados y la siguiente leyenda:
              </li>
            </ul>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Bajo protesta de decir verdad hago constar que la presente fotocopia
              fue tomada del documento original, mismo que cuenta con validez
              oficial y fue expedido por institución con reconocimiento
              gubernamental. Hago entrega a la empresa SKA TRACKING AND SECURITY
              S.A. de C.V. a los
              <Controller
                name="fecha_requisitos_pruebas"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="fecha_requisitos_pruebas"
                    type="date"
                    {...field}
                    className={`border rounded-md p-2 w-[150px] ml-2 font-bold ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-500" : "border-gray-400 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"}`}
                  />
                )}
              />
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <strong>Nombre:</strong> {queryEvaluado.data?.nombre || ""}{" "}
              {queryEvaluado.data?.apellido_paterno || ""}{" "}
              {queryEvaluado.data?.apellido_materno || ""}
              <br />
              <strong>Empresa:</strong>{" "}
              {queryEvaluado.data?.empresa_id?.nombre || ""}
              <br />
              <strong>Puesto:</strong> {queryEvaluado.data?.puesto || ""}
              <div className="mt-[50px]"></div>
              <strong>Firma:</strong> _______________________
            </p>

            <ul className={`list-disc text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <li>
                <strong>Documentación que deberá mostrar en copia</strong>
                <br />
                - Acta de nacimiento de sus dependientes económicos
                <br />
                - Tarjeta de circulación y factura de vehículos particulares
                <br />- Propiedad en bienes inmuebles (escrituras, compra-venta,
                donación, convenio, herencia, testamento, comodato, copropiedad,
                etc)
                <br />
                - Constancia de Situación Fiscal
                <br />- Procedimientos administrativos, procesos penales, carpetas
                de investigación, sanciones, recomendaciones, etc.
                <div className="mt-[50px]"></div>
                En el caso de que usted tenga ingresos por una actividad informal,
                deberá presentar comprobante
                <div className="mt-[50px]"></div>
                <strong>
                  Los documentos originales se devolverán una vez cotejados con la
                  copia.
                </strong>
              </li>
            </ul>

            <div className={`p-4 rounded-md border-2 ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-200 border-black"}`}>
              <p className={`text-justify font-bold leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                La presentación de documentos apócrifos, la falsedad de nombre y
                de su domicilio, se hará del conocimiento a la empresa por la que
                Usted se presenta a realizar las evaluaciones de Pruebas de
                Confianza.
              </p>
            </div>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}></p>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`bg-red-500 hover:bg-red-600 text-white ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 text-white ${isDarkMode ? "bg-green-600 hover:bg-green-700" : "bg-green-500"}`}
              >
                Guardar
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};